import React, { useEffect, useState } from 'react'

import { Checkbox as AntCheckbox, CheckboxProps as AntCheckboxProps } from 'antd'

import { CommandResponse } from 'common/hooks/useCommandRequest'

import Button from '../../general/Button'
import Icon from '../../general/Icon'

import './styles/checkbox.less'

export interface CheckboxProps extends AntCheckboxProps {
  disabled?: boolean
  onChange?: (e: any) => void
  className?: string
  id?: string
  defaultChecked?: boolean
  checked?: boolean
  value?: string | number
  white?: boolean
  childred?: JSX.Element
  onSave?: (name: string) => Promise<CommandResponse<unknown>>
  onDelete?: () => void
  onCancel?: () => void
  icon?: string
  hasActions?: boolean
  isSubmitting?: boolean
}

const EditableCheckboxButton: React.FC<CheckboxProps> = (props) => {
  const [showEdit, setShowEdit] = useState(false)
  const [newName, setNewName] = useState('')
  const [saveLoading, setSaveLoading] = useState(false)
  const { name, className, checked, icon, hasActions, onSave, onDelete, onCancel, isSubmitting = false } = props

  const handleSave = async () => {
    setSaveLoading(true)
    const result = await onSave(newName)
    if (result.completed) {
      setShowEdit(false)
      setSaveLoading(false)
    }
  }

  useEffect(() => {
    setNewName(name)
  }, [name])

  useEffect(() => {
    setShowEdit(isSubmitting)
  }, [isSubmitting])

  return (
    <div className={`checkbox__button ${className}`}>
      {showEdit && hasActions ? (
        <div className={`ant-btn pr-16 pl-8 py-20 ${checked ? 'outline-green' : ''} checkbox__button-wrapper`}>
          <div className="flex">
            <Button
              className="checkbox__button-button-section mr-8 p-0"
              onClick={() => {
                setShowEdit(false)
                setNewName(name)
                onCancel()
              }}
            >
              Cancel
            </Button>
            <Button
              loading={saveLoading}
              className="checkbox__button-button-section p-0"
              type="primary"
              onClick={handleSave}
            >
              <Icon className="fal fa-check mr-8" />
              Save
            </Button>
          </div>
          <div className="pl-8 pr-8">
            {icon && <Icon className={`${icon} mr-8`} />}
            <input
              type="text"
              autoFocus
              value={newName}
              className="checkbox__button-input"
              onChange={(e) => setNewName(e.target.value)}
            />
          </div>
        </div>
      ) : (
        <AntCheckbox
          {...props}
          className={`ant-btn pr-16 pl-8 py-16 ${checked ? 'outline-green' : ''} checkbox__button-wrapper`}
        >
          <div className="checkbox__button-label">
            <div className="flex flex__center pr-8">
              {icon && <Icon className={`${icon} mr-8 mt-2`} />}
              {hasActions ? (
                <input
                  type="text"
                  value={newName}
                  readOnly
                  className="checkbox__button-input"
                  onClick={(e) => {
                    setShowEdit(true)
                    e.preventDefault()
                  }}
                />
              ) : (
                <div className="checkbox__button-input">{newName}</div>
              )}
            </div>
            {hasActions && (
              <div className="checkbox__button-label-button">
                <Button type="text" onClick={() => setShowEdit(true)}>
                  <Icon type="far fa-pencil-alt" fontAwesome />
                </Button>
                <Button danger type="text" onClick={onDelete}>
                  <Icon className="fal fa-trash-alt" />{' '}
                </Button>
              </div>
            )}
          </div>
        </AntCheckbox>
      )}
    </div>
  )
}

export default EditableCheckboxButton
